<!-- HEADER -->
<app-header color="transparent"></app-header>

<!-- CONTENT -->
<ion-content class="padded" [class.isTablet]="tablet && !desktop">
  <section *ngIf="data">
    <!-- BREADCRUMBS -->
    <ul class="breadcrumb">
      <li>
        <a [routerLink]="'/'">Home</a
        ><ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li>
        <a [routerLink]="'/offers'">Offers</a
        ><ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li class="active">{{data?.offer.title}}</li>
    </ul>

    <!-- SHOP OVERVIEW -->
    <section
      class="shop-overview"
      [class.shop-overview-center-offer]="data?.offer.typeSettings?.centerOffer">
      <ion-grid class="ion-no-padding ion-no-margin">
        <ion-row>
          <!-- DESKTOP FEATURED IMAGE -->
          <ion-col size="12" size-md="7" *ngIf="desktop">
            <div
              class="shop-img-wrapper ion-align-items-center ion-justify-content-center">
              <app-img-format
                [aspectRatio]="'16:9'"
                [disableLazyLoad]="true"
                *ngIf="data?.offer.featuredImage"
                [src]="data.offer.featuredImage"
                [alt]="data?.offer.title"></app-img-format>

              <!-- SPONSOR -->
              <app-sponsor-overlay
                *ngIf="data?.offer?.advertise"
                [sponsor]="data.offer.advertise"></app-sponsor-overlay>
            </div>
          </ion-col>

          <ion-col size="12" size-md class="shop-overview-details">
            <ion-row class="ion-align-items-center">
              <!-- TITLE -->
              <ion-col>
                <h1 class="h2 shop-title">{{data.offer.title}}</h1>
              </ion-col>

              <!-- FAVORTIE & SHARE -->
              <ion-col size="auto" class="favorite">
                <app-favorite-item
                  [title]="data.offer.title"
                  [slug]="data.offer.slug"></app-favorite-item>
              </ion-col>
              <ion-col size="auto" class="social-share">
                <a (click)="presentPopover($event)">
                  <ion-icon
                    color="dark"
                    name="share-outline"
                    slot="icon-only"></ion-icon>
                </a>
              </ion-col>
            </ion-row>

            <!-- CATEGORY -->
            <ion-text color="tertiary">
              <h2 class="shop-category">
                <ng-container
                  *ngIf="
                    !data?.offer.typeSettings?.centerOffer && data?.offer.offerContext?.title
                  ">
                  {{ data.offer.offerContext.title | titlecase }} &nbsp;|&nbsp;
                </ng-container>
                {{ startDate | date: "d MMM y" | uppercase }} - {{ endDate |
                date: "d MMM y" | uppercase }}
              </h2>
            </ion-text>

            <!-- MOBILE FEATURED IMAGE -->
            <div
              *ngIf="!desktop"
              class="shop-img-wrapper ion-align-items-center ion-justify-content-center">
              <app-img-format
                [aspectRatio]="'16:9'"
                [disableLazyLoad]="true"
                *ngIf="data?.offer.featuredImage"
                [src]="data.offer.featuredImage"
                [alt]="data?.offer.title"></app-img-format>
            </div>

            <!-- STORE CURRENTLY OPEN/CLOSED -->
            <ion-text color="medium" class="shop-open">
              <p>{{data?.offer.offerContext.currentStatus}}</p>
            </ion-text>

            <!-- OPENING TIMES -->
            <ion-grid class="shop-time-list ion-no-padding">
              <ng-container
                *ngIf="data?.offer?.offerContext?.typeTrading && data?.offer?.offerContext?.typeTrading[0]; else mallTradingTimes">
                <ion-row
                  *ngFor="let day of data?.offer.offerContext.typeTrading">
                  <ion-col>{{day.dayName}}</ion-col>
                  <ion-col size="auto">
                    <ion-text>
                      <span *ngIf="day.open; else closedDay">
                        {{day.open_text}} - {{day.close_text}}
                      </span>
                      <ng-template #closedDay>
                        <span>Closed</span>
                      </ng-template>
                    </ion-text>
                  </ion-col>
                </ion-row>
              </ng-container>
              <ng-template #mallTradingTimes>
                <ion-row>
                  <ion-col>Monday</ion-col>
                  <ion-col size="auto">
                    <ion-text>
                      <span
                        *ngIf="data?.offer.offerContext.typeTrading.tradingEnabledMonday; else closedDay">
                        {{data?.offer.offerContext.typeTrading.tradingOpeningTimeMonday}}
                        -
                        {{data?.offer.offerContext.typeTrading.tradingClosingTimeMonday}}
                      </span>
                      <ng-template #closedDay>
                        <span>Closed</span>
                      </ng-template>
                    </ion-text>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>Tuesday</ion-col>
                  <ion-col size="auto">
                    <ion-text>
                      <span
                        *ngIf="data?.offer.offerContext.typeTrading.tradingEnabledTuesday; else closedDay">
                        {{data?.offer.offerContext.typeTrading.tradingOpeningTimeTuesday}}
                        -
                        {{data?.offer.offerContext.typeTrading.tradingClosingTimeTuesday}}
                      </span>
                      <ng-template #closedDay>
                        <span>Closed</span>
                      </ng-template>
                    </ion-text>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>Wednesday</ion-col>
                  <ion-col size="auto">
                    <ion-text>
                      <span
                        *ngIf="data?.offer.offerContext.typeTrading.tradingEnabledWednesday; else closedDay">
                        {{data?.offer.offerContext.typeTrading.tradingOpeningTimeWednesday}}
                        -
                        {{data?.offer.offerContext.typeTrading.tradingClosingTimeWednesday}}
                      </span>
                      <ng-template #closedDay>
                        <span>Closed</span>
                      </ng-template>
                    </ion-text>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>Thursday</ion-col>
                  <ion-col size="auto">
                    <ion-text>
                      <span
                        *ngIf="data?.offer.offerContext.typeTrading.tradingEnabledThursday; else closedDay">
                        {{data?.offer.offerContext.typeTrading.tradingOpeningTimeThursday}}
                        -
                        {{data?.offer.offerContext.typeTrading.tradingClosingTimeThursday}}
                      </span>
                      <ng-template #closedDay>
                        <span>Closed</span>
                      </ng-template>
                    </ion-text>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>Friday</ion-col>
                  <ion-col size="auto">
                    <ion-text>
                      <span
                        *ngIf="data?.offer.offerContext.typeTrading.tradingEnabledFriday; else closedDay">
                        {{data?.offer.offerContext.typeTrading.tradingOpeningTimeFriday}}
                        -
                        {{data?.offer.offerContext.typeTrading.tradingClosingTimeFriday}}
                      </span>
                      <ng-template #closedDay>
                        <span>Closed</span>
                      </ng-template>
                    </ion-text>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>Saturday</ion-col>
                  <ion-col size="auto">
                    <ion-text>
                      <span
                        *ngIf="data?.offer.offerContext.typeTrading.tradingEnabledSaturday; else closedDay">
                        {{data?.offer.offerContext.typeTrading.tradingOpeningTimeSaturday}}
                        -
                        {{data?.offer.offerContext.typeTrading.tradingClosingTimeSaturday}}
                      </span>
                      <ng-template #closedDay>
                        <span>Closed</span>
                      </ng-template>
                    </ion-text>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>Sunday</ion-col>
                  <ion-col size="auto">
                    <ion-text>
                      <span
                        *ngIf="data?.offer.offerContext.typeTrading.tradingEnabledSunday; else closedDay">
                        {{data?.offer.offerContext.typeTrading.tradingOpeningTimeSunday}}
                        -
                        {{data?.offer.offerContext.typeTrading.tradingClosingTimeSunday}}
                      </span>
                      <ng-template #closedDay>
                        <span>Closed</span>
                      </ng-template>
                    </ion-text>
                  </ion-col>
                </ion-row>
              </ng-template>
            </ion-grid>

            <!-- SPECIAL DAYS -->
            <ion-grid
              *ngIf="data?.offer?.offerContext?.typeDays"
              class="shop-time-list ion-no-padding">
              <ion-row *ngFor="let day of data.offer.offerContext.typeDays">
                <ion-col>
                  <ion-text color="medium">
                    {{day.label}} | {{day.date | date:"d MMM"}}
                  </ion-text>
                </ion-col>
                <ion-col size="auto">
                  <ng-container *ngIf="!day.isDay; else specialDayClosed">
                    <ion-text color="medium">
                      <span> {{day.openTime}} - {{day.closeTime}} </span>
                    </ion-text>
                  </ng-container>
                  <ng-template #specialDayClosed>
                    <ion-text color="medium">
                      <span> Closed </span>
                    </ion-text>
                  </ng-template>
                </ion-col>
              </ion-row>
            </ion-grid>

            <!-- LOCATION INFO -->
            <ion-grid
              *ngIf="data?.offer?.typeSettings?.centerOffer"
              class="center-details ion-no-margin ion-no-padding">
              <ion-row>
                <ion-col size="6" class="ion-align-items-center">
                  <ion-icon color="dark" name="location-outline"></ion-icon>
                  <ion-text color="dark">
                    {{ data?.offer?.typeSettings?.offerLocation }}
                  </ion-text>
                </ion-col>
                <ion-col size="6" class="ion-align-items-center ion-text-end">
                  <ion-icon color="dark" name="call-outline"></ion-icon>
                  <ion-text color="dark">
                    <a
                      [href]="'tel:'+data?.offer?.typeSettings?.offerContact"
                      target="_blank"
                      style="text-decoration: none">
                      {{ data?.offer?.typeSettings?.offerContact }}
                    </a>
                  </ion-text>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-col>
        </ion-row>
      </ion-grid>
    </section>

    <!-- SHOP DETAILS -->
    <section
      *ngIf="!data?.offer?.typeSettings?.centerOffer && data?.offer?.offerContext?.typeGeneral"
      class="shop-details">
      <ion-grid class="ion-no-margin ion-no-padding">
        <ion-row class="ion-justify-content-between">
          <ion-col
            *ngIf="data.offer.offerContext.typeGeneral.email_address"
            size-md="auto">
            <ion-item>
              <ion-icon name="mail-outline" slot="start"></ion-icon>
              <a
                [href]="'mailto:'+data.offer.offerContext.typeGeneral.email_address"
                target="_blank"
                >Email</a
              >
            </ion-item>
          </ion-col>
          <ion-col
            *ngIf="data.offer.offerContext.typeGeneral.telephone_number"
            size-md="auto">
            <ion-item>
              <ion-icon name="call-outline" slot="start"></ion-icon>
              <ng-container *ngIf="desktop; else mobileTelLink">
                {{data.offer.offerContext.typeGeneral.telephone_number}}
              </ng-container>
              <ng-template #mobileTelLink>
                <a
                  [href]="'tel:'+data.offer.offerContext.typeGeneral.telephone_number"
                  target="_blank">
                  {{data.offer.offerContext.typeGeneral.telephone_number}}
                </a>
              </ng-template>
            </ion-item>
          </ion-col>
          <ion-col
            *ngIf="!desktop && (!data.offer.offerContext.typeGeneral.email_address || !data.offer.offerContext.typeGeneral.telephone_number)"></ion-col>
          <ion-col *ngIf="websiteUrl" size="12" size-md="auto">
            <ion-item>
              <ion-icon name="globe-outline" slot="start"></ion-icon>
              <a [href]="websiteUrl" target="_blank"
                >{{data.offer.offerContext.typeGeneral.website}}</a
              >
            </ion-item>
          </ion-col>
          <ion-col size-md="auto">
            <ion-item>
              <ion-icon name="locate-outline" slot="start"></ion-icon>
              <ion-text color="dark"
                >Shop {{data.offer.offerContext.typeGeneral.store_number}},
                {{data.offer.offerContext.typeGeneral.level}}</ion-text
              >
            </ion-item>
          </ion-col>
          <ion-col size="auto">
            <ion-item>
              <ion-icon name="enter-outline" slot="start"></ion-icon>
              <ion-text color="dark"
                >Entrance
                {{data.offer.offerContext.typeGeneral.entrance}}</ion-text
              >
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-grid>
    </section>

    <!-- BODY -->
    <section class="shop-content">
      <app-dynamic-html
        [data]="data?.offer.body"
        [formTitle]="data.offer.title"></app-dynamic-html>

      <app-button
        *ngIf="data.offer.typeSettings?.ctaText"
        [icon]="{ name: 'arrow-right', position: 'right' }" 
        position="left"
        [href]="ctaUrl"
        target="_blank">
        {{ data.offer.typeSettings.ctaText }}
      </app-button>

      <!-- SPONSOR STRIP -->
      <app-sponsor-strip
        *ngIf="data?.offer?.advertise"
        [sponsorStrip]="data?.offer?.advertise"></app-sponsor-strip>
    </section>

    <!-- RELATED CONTENT -->
    <section
      class="related-content ion-content-stretched swiper-stretched"
      *ngIf="data?.relatedContent && data?.relatedContent.length > 0">
      <ion-text color="dark" class="ion-text-center">
        <h2 class="related-content-title">Related Offers</h2>
      </ion-text>
      <ion-slides pager="true" [options]="slideOpts">
        <ion-slide
          *ngFor="let item of data?.relatedContent"
          class="ion-align-items-start ion-justify-content-start">
          <app-card
            [data]="item"
            [showType]="true"
            [img]="{ url: item.featuredImage, alt: item.title, aspectRatio:'16:9' }"
            [hideCategory]="true"
            class="card-boxed"></app-card>
        </ion-slide>
      </ion-slides>
    </section>
  </section>

  <!-- CONTACT / CTA STRIP -->
  <app-contact-strip></app-contact-strip>

  <!-- FOOTER -->
  <app-footer></app-footer>
</ion-content>
